import React from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Check } from 'lucide-react';
import './RoomsSection.css';

const RoomsSection = ({ rooms }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="salas" className="rooms-section">
      <div className="rooms-container">
        <div className="section-header">
          <h2 className="section-title">Nuestras Salas</h2>
          <p className="section-description">
            Espacios diseñados especialmente para crear un ambiente seguro, estimulante y acogedor
            <br />
            donde cada niño puede desarrollar su máximo potencial.
          </p>
        </div>

        <div className="rooms-grid">
          {rooms.map((room, index) => (
            <Card key={room.id || index} className="room-card">
              <div className="room-image-wrapper">
                <img
                  src={room.image}
                  alt={room.title}
                  className="room-image"
                />
                <div className="room-label">{room.label}</div>
              </div>
              <div className="room-content">
                <h3 className="room-title">{room.title}</h3>
                <p className="room-description">{room.description}</p>
                <div className="room-features">
                  {room.features.map((feature, idx) => (
                    <div key={idx} className="room-feature">
                      <Check className="feature-icon" size={16} />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </Card>
          ))}
        </div>

        <div className="visit-cta">
          <div className="visit-content">
            <h3 className="visit-title">¿Quieres conocer nuestras instalaciones?</h3>
            <p className="visit-description">
              Te invitamos a visitar nuestro centro. Conoce nuestros espacios, al equipo y resuelve todas tus dudas en persona.
            </p>
          </div>
          <Button
            className="visit-button"
            onClick={() => scrollToSection('contacto')}
          >
            Agendar Visita
          </Button>
        </div>
      </div>
    </section>
  );
};

export default RoomsSection;
